'use es6';

import { Record } from 'immutable';
import { SLINKY } from 'HubStyleTokens/colors';
export default Record({
  showSalesAd: true,
  primaryColor: SLINKY,
  secondaryColor: SLINKY,
  logoUrl: null
}, 'BrandingRecord');